import { rem } from '@Utils/styles';
import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PopupDetailsWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: ${rem(12)};
`;
